export function isSsr() {
  return !!process.env.IS_SSR && process.env.NODE_ENV !== 'test';
}
